import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NotificationComponent} from "./notification.component";
import {ToastModule} from 'primeng/toast';
import {TranslateModule} from "@ngx-translate/core";
import {ButtonModule} from "primeng/button";
import {ThumbnailModule} from '../thumbnail/thumbnail.module';
import {PipesModule} from '../../core/pipes/pipes.module';
import {NotificationItemComponent} from './notification-item.component';

@NgModule({
  imports: [
    CommonModule,
    ToastModule,
    TranslateModule,
    ButtonModule,
    ThumbnailModule,
    PipesModule,
  ],
  declarations: [NotificationComponent, NotificationItemComponent],
  exports: [NotificationComponent, NotificationItemComponent]
})
export class NotificationModule {
}
